import React, { useState } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { ArrowDown2, ArrowUp2 } from 'iconsax-react';

interface IProps {
  value?: any;
  defaultValue?: any;
  onChange: (e: any) => void;
  options: any;
}

const SelectBox: React.FC<IProps> = ({
  value,
  onChange,
  options,
  defaultValue,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleOpenChange = (open) => {
    setIsOpen(open);
  };

  return (
    <SelectBoxStyled
      size='large'
      bordered={false}
      open={isOpen}
      onDropdownVisibleChange={handleOpenChange}
      suffixIcon={
        !isOpen ? (
          <ArrowDown2 size='18' color='#000000' />
        ) : (
          <ArrowUp2 size='18' color='#000000' />
        )
      }
      style={{ width: '100%' }}
      defaultValue={defaultValue ? defaultValue : undefined}
      value={value ? value : undefined}
      onChange={onChange}
      options={options}
    />
  );
};

const SelectBoxStyled = styled(Select)`
  .ant-select-selector {
    border: 1px solid ${theme.colors.gray_6} !important;
    background: #ffffff !important;
    padding: 0 16px !important;
  }
  .ant-select-focused {
    border: none !important;
  }
  .ant-select-selection-item {
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.normal};
    line-height: 24px;
    letter-spacing: 0.1px;
    color: ${theme.colors.dark_500};
  }
`;

export default SelectBox;
